import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "codeInput", "webauthnBtn"]

  async useSecurityKey(event) {
    event.preventDefault()
    this.webauthnBtnTarget.disabled = true
    try {
      const optionsRes = await fetch('/login/2fa/webauthn/options', {
        method: 'GET',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      })
      const options = await optionsRes.json()
      if (options.error) {
        alert(options.error)
        this.webauthnBtnTarget.disabled = false
        return
      }
      const credential = await navigator.credentials.get({
        publicKey: this._webauthnGetOptions(options)
      })
      if (!credential) {
        this.webauthnBtnTarget.disabled = false
        return
      }
      const body = { credential: this._credentialToJSON(credential) }
      const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
      const verifyRes = await fetch('/login/2fa/webauthn/verify', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-CSRF-Token': token || '',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(body)
      })
      const result = await verifyRes.json()
      this.webauthnBtnTarget.disabled = false
      if (result.redirect_url) {
        window.location.href = result.redirect_url
      } else if (result.error) {
        alert(result.error)
      }
    } catch (err) {
      this.webauthnBtnTarget.disabled = false
      alert(err.message || 'Failed.')
    }
  }

  _webauthnGetOptions(options) {
    const o = { ...options }
    if (o.challenge != null) o.challenge = this._toBuffer(o.challenge)
    const credentials = o.allowCredentials ?? o.allow ?? []
    if (credentials.length) {
      o.allowCredentials = credentials.map(c => ({
        ...c,
        id: this._toBuffer(typeof c.id === 'object' && c.id != null && !ArrayBuffer.isView(c.id) && !(c.id instanceof ArrayBuffer) ? c.id?.id ?? c.id : c.id)
      }))
    }
    delete o.allow
    return o
  }

  _toBuffer(value) {
    if (typeof value === 'string') {
      return this._base64UrlDecode(value)
    }
    if (Array.isArray(value) || ArrayBuffer.isView(value)) {
      return new Uint8Array(value)
    }
    return value
  }

  _base64UrlDecode(str) {
    if (typeof str !== 'string') return str
    let base64 = str.replace(/-/g, '+').replace(/_/g, '/')
    const pad = base64.length % 4
    if (pad) base64 += (pad === 2 ? '==' : '=')
    return Uint8Array.from(atob(base64), c => c.charCodeAt(0))
  }

  _credentialToJSON(credential) {
    return {
      id: credential.id,
      rawId: this._base64UrlEncode(credential.rawId),
      type: credential.type,
      response: {
        clientDataJSON: this._base64UrlEncode(credential.response.clientDataJSON),
        authenticatorData: this._base64UrlEncode(credential.response.authenticatorData),
        signature: this._base64UrlEncode(credential.response.signature),
        userHandle: credential.response.userHandle ? this._base64UrlEncode(credential.response.userHandle) : null
      }
    }
  }

  _base64UrlEncode(buf) {
    const base64 = btoa(String.fromCharCode(...new Uint8Array(buf)))
    return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
  }
}
